export const LINK_MOVEMENT_PAGE_NAVIGATE = 'linked-movement-page-navigate'
export const SELECT_ITEM_MULTIPLE_FORM_ITEM_SELECTED = 'select-item-multiple-form-item-selected'
export const SELECT_ITEM_MULTIPLE_MODAL_MULTIPLE_ITEMS_SELECTED = 'select-item-multiple-modal-items-selected'